import React from 'react';
import type { IconProps } from '../types';

export const TabStudy = (props: IconProps) => (
  <svg
    width="22px"
    height="23px"
    viewBox="0 0 22 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>tab-study</title>
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="4"
        y="4"
        width="14"
        height="14"
        rx="1"
      />
    </g>
  </svg>
);

export default TabStudy;
